import { rgba, typography } from '../core/utils';

import { Card } from './primitives.styles';
import styled from '@emotion/styled';
import { theme } from '../core/theme';
import { tokens } from '../core/tokens';

const TableCard = styled(Card)`
   padding: 0;
   overflow: hidden;
`;

const Table = styled.table`
   width: 100%;
   border-collapse: collapse;
`;

const Head = styled.thead`
   background-color: ${theme.colors.bg.secondary};
`;

const Body = styled.tbody``;

const HeaderRow = styled.tr`
   border-bottom: 2px solid ${theme.colors.border.default};
`;

const HeaderCell = styled.th<{ $align?: 'left' | 'center' | 'right' }>`
   padding: ${tokens.space.sm} ${tokens.space.md};
   ${typography.bodyL}
   font-weight: ${tokens.font.weight.semibold};
   color: ${theme.colors.text.secondary};
   text-align: ${({ $align = 'left' }) => $align};
   white-space: nowrap;
   border-right: 1px solid ${theme.colors.border.subtle};
   &:last-child {
      border-right: none;
   }
`;

const Row = styled.tr<{ $groupEnd?: boolean }>`
   border-bottom: ${({ $groupEnd }) => ($groupEnd ? '2px solid' : '1px solid')} ${theme.colors.border.subtle};
   ${({ $groupEnd }) => $groupEnd && `border-bottom-color: ${theme.colors.border.default};`}
   &:hover {
      background-color: ${theme.colors.bg.secondary};
   }
`;

const LabelCell = styled.td`
   padding: ${tokens.space.sm} ${tokens.space.md};
   ${typography.bodyM}
   font-weight: ${tokens.font.weight.semibold};
   color: ${theme.colors.text.primary};
   background-color: ${theme.colors.bg.secondary};
   border-right: 2px solid ${theme.colors.border.default};
   vertical-align: middle;
`;

const SubLabelCell = styled.td`
   padding: ${tokens.space.xs} ${tokens.space.sm};
   font-size: ${tokens.font.size.sm};
   color: ${theme.colors.text.tertiary};
   background-color: ${theme.colors.bg.secondary};
   border-right: 1px solid ${theme.colors.border.subtle};
   width: 50px;
   text-align: right;
`;

const Cell = styled.td<{ $align?: 'left' | 'center' | 'right'; $selected?: boolean }>`
   padding: ${tokens.space.xs} ${tokens.space.sm};
   text-align: ${({ $align = 'center' }) => $align};
   border-right: 1px solid ${theme.colors.border.subtle};
   background-color: ${({ $selected }) => ($selected ? rgba(theme.colors.state.info, 0.1) : 'transparent')};
   &:last-child {
      border-right: none;
   }
`;

export const DataTable = {
   Card: TableCard,
   Table,
   Head,
   Body,
   HeaderRow,
   HeaderCell,
   Row,
   LabelCell,
   SubLabelCell,
   Cell,
};
